<template>
    <li class="mb_menu__li_child">
        <slot :childOpen="isOpen" :toggleChild="toggle"></slot>
    </li>
</template>

<script>
export default {
    data(){
        return {
            isOpen: false
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        }
    }
}
</script>